import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { formatMoney, num } from "./plConstants";

const AmountCell = ({ amount, count, color }) => (
  <TableCell align="right">
    <Typography variant="body2" sx={{ fontWeight: 700, color }}>
      {formatMoney(amount)}
    </Typography>
    <Typography variant="caption" color="text.secondary">
      {num(count)} {num(count) === 1 ? "entry" : "entries"}
    </Typography>
  </TableCell>
);

// Commission and bonus, claimed vs pending — laid out as an aligned 2-column table.
const ClaimSummary = ({ claim }) => {
  const c = claim || {};
  const rows = [
    {
      label: "Claimed",
      color: "success.main",
      commissionAmount: c.commissionClaimedAmount,
      commissionCount: c.commissionClaimedCount,
      bonusAmount: c.bonusClaimedAmount,
      bonusCount: c.bonusClaimedCount,
    },
    {
      label: "Pending",
      color: "warning.main",
      commissionAmount: c.commissionPendingAmount,
      commissionCount: c.commissionPendingCount,
      bonusAmount: c.bonusPendingAmount,
      bonusCount: c.bonusPendingCount,
    },
  ];

  return (
    <Paper elevation={1} sx={{ p: 2, borderRadius: 2, height: "100%" }}>
      <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>
        Claim Tracking
      </Typography>
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell />
              <TableCell align="right" sx={{ fontWeight: 700 }}>
                Commission
              </TableCell>
              <TableCell align="right" sx={{ fontWeight: 700 }}>
                Bonus
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((r) => (
              <TableRow key={r.label}>
                <TableCell sx={{ verticalAlign: "top" }}>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <Box sx={{ width: 8, height: 8, borderRadius: "50%", bgcolor: r.color }} />
                    <Typography variant="body2" sx={{ fontWeight: 600 }}>
                      {r.label}
                    </Typography>
                  </Box>
                </TableCell>
                <AmountCell amount={r.commissionAmount} count={r.commissionCount} color={r.color} />
                <AmountCell amount={r.bonusAmount} count={r.bonusCount} color={r.color} />
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default ClaimSummary;
